/** Define all route names separated by feature */
export namespace RouteNameEnum {
  export const auth = Object.freeze({
    login: '/auth/login',
    logout: '/auth/logout',
  });
  export const dashboard = Object.freeze({
    index: '/dashboard',
  });
  export const boUser = Object.freeze({
    index: '/bo-user',
    edit: '/bo-user/edit/:id',
  });
  export const course = Object.freeze({
    index: '/course',
    create: '/course/create',
    detail: '/course/detail/:id',
    edit: '/course/edit/:id',
  });
  export const product = Object.freeze({
    index: '/product',
    create: '/product/create',
    detail: '/product/detail/:id',
    importCode: '/product/importCode/:id',
    edit: '/product/edit/:id',
  });
  export const customer = Object.freeze({
    index: '/customer',
    detail: '/customer/detail/:id',
    edit: '/customer/edit/:id',
    editAlumni: '/customer/edit-alumni/:id',
    manageUprankCoin: '/customer/manage-uprank-coin/:id',
    manageProduct: '/customer/manage-product/:id',
    voucher: '/customer/voucher/:customerId',
  });
  export const orderTransaction = Object.freeze({
    index: '/order-transaction',
    detail: '/order-transaction/detail/:id',
  });

  export const chat = Object.freeze({
    setting: '/chat-setting',
    chatRoom: '/chat-room',
  });

  export const notification = Object.freeze({
    index: '/notification',
    create: '/notification/create',
    detail: '/notification/detail/:id',
  });

  export const rearrange = Object.freeze({
    index: '/rearrange',
    categoryRearrange: '/rearrange/categories/:productType',
    productIndex: '/rearrange/categories/products/:categoryId',
    productRearrange: '/rearrange/products/:categoryId',
  });

  export const featuredBanner = Object.freeze({
    index: '/featuredBanner',
  });

  export const news = Object.freeze({
    index: '/news',
    create: '/news/create',
    detail: '/news/detail/:id',
    edit: '/news/edit/:id',
  });

  export const featuredContent = Object.freeze({
    index: '/featured-content',
    create: '/featured-content/create',
    detail: '/featured-content/detail/:id',
    edit: '/featured-content/edit/:id',
  });

  export const questionnaires = Object.freeze({
    index: '/questionnaires',
    detail: '/questionnaire/:id',
    createPersonalInfo: '/questionnaire/create/personalInformation',
    editPersonalInfo: '/questionnaire/edit/personalInformation/:id',
    previewQuestionnaireMedical: '/questionnaire/:id/questionnaireMedical/preview',
    previewQuestionnaireHealth: '/questionnaire/:id/questionnaireHealth/preview',
    previewQuestionnairePreArrival: '/questionnaire/:id/questionnairePreArrival/preview',

  });

  export const event = Object.freeze({
    index: '/event',
    create: '/event/create',
    detail: '/event/detail/:id',
    edit: '/event/edit/:id',
  });

  export const reports = Object.freeze({
    index: '/reports',
    chat: '/reports/chats',
    feedback: '/reports/feedback',
  });
}
